// var crPickupLocaleExtension = true;
 var crPickupLocale = 'it';

document.addEventListener('crPickupActivated', function (e) {
	jqCR('#store-search').prepend('<input type="text" name="pickup-store-search" id="pickup-store-search" onkeyup="storePickup.storeFilter()" placeholder="Cerca..." class="valid" aria-invalid="false">')            	
})

document.addEventListener('crJQActivated', function (e) {  
  setTimeout(() => {
	var form = storePickup.submitForm();
    jqCR(form).attr('action', '/checkout?locale=it')
  }, 1000);
})
